import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=e8bcd682&scoped=true&"
import script from "./AddCategory.vue?vue&type=script&lang=js&"
export * from "./AddCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddCategory.vue?vue&type=style&index=0&id=e8bcd682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bcd682",
  null
  
)

export default component.exports